import { Configuration, LogLevel, RedirectRequest } from '@azure/msal-browser'

/**
 * Azure AD / Entra ID SSO configuration.
 * Values come from environment variables (see .env.example).
 */
export const msalConfig: Configuration = {
  auth: {
    clientId:    import.meta.env.VITE_AZURE_CLIENT_ID,
    authority:   `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    // Redirige SIEMPRE al origen actual (dominio propio, Container App o localhost),
    // no a una URL fija horneada en build. Sin esto, entrar por planning.air-valperfumes.com
    // te devolvía a la URL del Container App → sesión perdida → segundo login.
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        if (import.meta.env.DEV) console.debug(`[MSAL][${LogLevel[level]}]`, message)
      },
    },
  },
}

/**
 * Scopes requested when acquiring a token for the backend API.
 * The backend exposes a custom scope registered in Azure AD App Registration.
 */
export const apiTokenRequest: RedirectRequest = {
  scopes: [
    `api://${import.meta.env.VITE_BACKEND_CLIENT_ID}/access_as_user`,
  ],
}

/**
 * Scopes for login (includes openid / profile for user identity).
 * IMPORTANT: only Graph scopes here — mixing resources in one request breaks MSAL.
 * The API token (Dashboard.Read) is acquired separately via acquireTokenSilent.
 */
export const loginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'User.Read'],
}
